<template>
  <div id="footer">
    <div class="logo">
      <img src="/images/footer_logo.gif" alt="" />
    </div>
    <div class="footer-content">
      <div class="footer-link">
        <ul class="horizon">
          <li>
            <router-link to="/company/about">회사소개</router-link>
          </li>
          <li>|</li>
          <li>
            <router-link to="/company/map">찾아오시는길</router-link>
          </li>
          <li>|</li>
          <li class="privacy">
            <router-link to="/info/policy">개인정보취급방침</router-link>
          </li>
        </ul>
      </div>
      <div class="info">
        <div class="address">
          (주) 모컨스 | 서울특별시 송파구 백제고분로 89, 4층 (잠실동,영우빌딩)
          TEL 02)553-4508 FAX 02)553-4510
        </div>
        <div class="copyright">
          Copyright (c) 2018 MOCONS Co., Ltd. All rights reserved.
        </div>
      </div>
    </div>
    <div class="since">
      <img src="/images/since.gif" alt="" />
    </div>
    <div class="family">
      <div class="family-pop" :class="classActive">
        <ul>
          <li>
            <a
              href="https://www.thielmann.co.kr"
              @click="familyPopToggle"
              target="_blank"
            >
              <div>틸만코리아</div>
            </a>
          </li>
          <li>
            <a
              href="http://www.malongo.co.kr"
              @click="familyPopToggle"
              target="_blank"
            >
              <div>말롱고</div>
            </a>
          </li>
        </ul>
      </div>
      <div class="default" @click="familyPopToggle">
        <img src="/images/family_arrow.gif" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data() {
    return {
      classActive: ''
    }
  },
  methods: {
    familyPopToggle() {
      if (this.classActive === '') {
        this.classActive = 'active'
      } else {
        this.classActive = ''
      }
    }
  }
}
</script>

<style scoped>
#footer {
  width: 1000px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 40px;
}
#footer div.footer-content {
  font-size: 12px;
}
#footer div.footer-link {
  width: 360px;
  margin-bottom: 10px;
}
#footer div.footer-link ul.horizon {
  justify-content: space-between;
}
#footer ul li {
  cursor: pointer;
}
#footer ul li.privacy {
  color: #d58053;
}
#footer div.family {
  position: relative;
  font-size: 14px;
}
#footer div.family div.family-pop {
  position: absolute;
  display: none;
  box-sizing: border-box;
  bottom: 20px;
  width: 168px;
  padding: 4px;
  border: 1px solid #c9c9c9;
  background: #fff;
}
#footer div.family div.family-pop.active {
  display: block;
}
#footer div.family div.family-pop ul li {
  padding: 4px;
  width: 100%;
}
#footer div.family div.family-pop ul li a div {
  width: 148px;
  padding: 2px;
}
#footer div.family div.family-pop ul li a:hover {
  outline-style: auto;
  color: red;
}
#footer div.family div.family-pop ul li a:hover div {
  background: #ccc;
}
#footer div.family div.default {
  width: 168px;
  height: 20px;
}
</style>
